module.exports = __webpack_public_path__ + "img/benefit_suite-tickets.22023772.jpg";